import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderByDisplay' })
export class OrderByDisplayPipe implements PipeTransform {
  transform(value: any[]): any[] {
    return [...value].sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));
  }
}
